import { render, staticRenderFns } from "./chooseLabel.vue?vue&type=template&id=c979d3d0&scoped=true"
import script from "./chooseLabel.vue?vue&type=script&lang=js"
export * from "./chooseLabel.vue?vue&type=script&lang=js"
import style0 from "./chooseLabel.vue?vue&type=style&index=0&id=c979d3d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c979d3d0",
  null
  
)

export default component.exports